<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { PhClock, PhMapPin } from '@phosphor-icons/vue';
import { useBookingViewStore } from '@/stores/booking-view-store';

const { t } = useI18n();
const calendarStore = useBookingViewStore();

const { appointment } = storeToRefs(calendarStore);
</script>

<template>
  <div class="booking-header">
    <div class="booking-header-meta">
      <div class="booking-header-time-place">
        <div class="booking-header-time-place-item">
          <ph-clock size="16" />
          <span>{{ t('units.minutes', { value: appointment.slot_duration }) }}</span>
        </div>
        <div class="booking-header-time-place-item">
          <ph-map-pin size="16" />
          <span>{{ t('label.onlineMeeting') }}</span>
        </div>
      </div>
    </div>

    <p class="booking-header-kicker">{{ t('text.bookATimeToMeetWith', { name: appointment.owner_name }) }}</p>
    <h2 data-testid="booking-view-title-text">
      {{ appointment.title }}
    </h2>
    <p v-if="appointment.details" class="booking-header-details">{{ appointment.details }}</p>
  </div>
</template>

<style scoped>
@import '@/assets/styles/custom-media.pcss';

.booking-header {
  margin-block-end: 2rem;
  font-family: Inter, sans-serif;

  p, strong {
    line-height: 1.32;
    color: var(--colour-ti-base);
  }

  strong {
    font-weight: 700;
  }

  .booking-header-meta {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.75rem;
  }

  .booking-header-kicker {
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-size: 0.7rem;
    color: var(--colour-ti-muted);
    margin-bottom: 0.25rem;
  }

  h2 {
    font-size: 1.35rem;
    font-weight: 700;
    color: var(--colour-ti-base);
    margin-bottom: 0.35rem;
    word-break: break-word;
  }

  .booking-header-details {
    color: var(--colour-ti-secondary);
    font-size: 0.9rem;
  }

  .booking-header-time-place {
    display: flex;
    align-items: center;
    gap: 1.5rem;

    .booking-header-time-place-item {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.85rem;
      color: var(--colour-ti-secondary);
    }
  }
}

@media (--md) {
  .booking-header {
    max-width: 100%;
  }
}
</style>
